import React from "react";
import classNames from "classnames";
import styles from "./Alert.module.scss";

type AlertVariant = "default" | "cta" | "danger" | "warning";

interface AlertProps {
    variant?: AlertVariant;
    className?: string;
    header?: string;
    children: React.ReactNode;
}

/** @deprecated Do not add new Alert call sites. No successor yet — do not substitute Toast or a one-off. */
export const Alert: React.FC<AlertProps> = ({
    variant = "default",
    className,
    header,
    children,
}) => (
    <div
        className={classNames(styles.alert, styles[variant], className)}
        role="alert"
    >
        {header && <header className={styles.header}>{header}</header>}
        {children}
    </div>
);
